import React from 'react';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';
function scrollToForm() {
  document.getElementById('lead-form')?.scrollIntoView({
    behavior: 'smooth'
  });
}
export function HeroSection() {
  return <section className="w-full bg-blue-50/60" data-id="element-39">
      <div className="mx-auto grid max-w-6xl items-center gap-8 px-5 py-10 sm:px-6 lg:grid-cols-2 lg:gap-12 lg:py-14" data-id="element-40">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: [0.16, 1, 0.3, 1]
      }} data-id="element-41">
          <h1 className="text-2xl font-semibold leading-tight tracking-tight text-slate-900 sm:text-3xl lg:text-4xl" data-id="element-42">
            Эндопротезирование коленного и тазобедренного суставов в
            Санкт-Петербурге
          </h1>

          <p className="mt-4 text-lg font-medium text-blue-700" data-id="element-43">
            3000+ операций · 20 лет практики · принимаем пациентов из всех
            регионов
          </p>

          <p className="mt-4 text-lg leading-relaxed text-slate-600" data-id="element-44">
            Операция по квоте ОМС — бесплатно для пациента. Пришлите снимки, и
            мы проконсультируем вас перед операцией.
          </p>

          <div className="mt-6" data-id="element-45">
            <button type="button" onClick={scrollToForm} className="w-full rounded-2xl bg-blue-600 px-7 py-4 text-lg font-semibold text-white shadow-sm transition hover:bg-blue-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 sm:w-auto" data-id="element-46">
              Записаться на консультацию перед операцией
            </button>
            <p className="mt-3 flex items-center gap-2 text-base text-slate-500" data-id="element-47">
              <Clock className="h-4 w-4" aria-hidden="true" data-id="element-48" />
              Ответ в течение 24 часов
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.1,
        ease: [0.16, 1, 0.3, 1]
      }} className="overflow-hidden rounded-3xl border border-blue-100 bg-white shadow-sm" data-id="element-49">
          <img src="https://cdn.magicpatterns.com/uploads/eJ9GmqD8BE6zT61S2xcFWS/uhiCsadUZlnGtNCwIkqnk8TVdaDX_XAHoEsZcmGHsIrzu0JHjkKMdy05kb8h4vxLH9qj4cA7uiOI7ykGQxwV56Qu.jpg" alt="Врач в белом халате рассматривает рентгеновский снимок коленного сустава" className="h-80 w-full object-cover object-top sm:h-96 lg:h-[520px]" data-id="element-50" />
        </motion.div>
      </div>
    </section>;
}